export const INVITE_USERS_ENDPOINT = '/gateway/api/invitations/invite';
export const INVITE_USERS_WITHIN_ORG_ENDPOINT =
	'/gateway/api/growth/groot-invite-within-org/invite';
